/** Único Meta Pixel activo en la landing: KETO 4P — 500 Recetas Keto. */
const PIXEL_ID = '1705136450541998'

/** Shared product parameters for every Meta Pixel commerce event. */
export const PRODUCT_EVENT_PARAMS = {
  content_name: 'KETO 4P — 500 Recetas Keto',
  content_category: 'Producto Digital',
  content_type: 'product',
  value: 12990,
  currency: 'ARS',
} as const

/** Milliseconds during which a repeated InitiateCheckout click is ignored. */
const CHECKOUT_DEBOUNCE_MS = 1500

let viewContentSent = false
let lastCheckoutSentAt = 0

declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void
      queue?: unknown[]
      push?: unknown
      loaded?: boolean
      version?: string
    }
    _fbq?: unknown
  }
}

/**
 * Injects the Meta Pixel base code once, globally, for every route.
 * Guarded so the script and the PageView event are never duplicated.
 */
export function initMetaPixel(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (window.fbq) return

  /* eslint-disable */
  // Meta Pixel Code
  ;(function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
    if (f.fbq) return
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    if (!f._fbq) f._fbq = n
    n.push = n
    n.loaded = !0
    n.version = '2.0'
    n.queue = []
    t = b.createElement(e)
    t.async = !0
    t.src = v
    s = b.getElementsByTagName(e)[0]
    // The pixel boots after first paint, when the document may no longer have
    // any <script> node to anchor to — fall back to <head>/<body>.
    if (s && s.parentNode) {
      s.parentNode.insertBefore(t, s)
    } else {
      ;(b.head || b.body || b.documentElement).appendChild(t)
    }
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')

  window.fbq?.('init', PIXEL_ID)
  window.fbq?.('track', 'PageView')
  /* eslint-enable */

  // NOTE: no <noscript> tracking-pixel fallback is injected here on purpose.
  // A <noscript> element built with document.createElement() does NOT behave
  // like a parsed one: its children stay live DOM nodes, so the 1x1 <img>
  // actually loads while JavaScript is enabled and Meta receives a SECOND
  // PageView (the `ev=PageView&noscript=1` hit). Since this whole function
  // only ever runs when scripting is available, the fallback could never
  // serve its purpose anyway — the JS PageView above is the single source.
  //
  // Defensive cleanup for sessions that already injected the old node.
  document.getElementById('meta-pixel-noscript')?.remove()

  trackViewContent()
}

/** Fires ViewContent once per page load for the product page. */
export function trackViewContent(): void {
  if (typeof window === 'undefined' || viewContentSent) return
  viewContentSent = true
  window.fbq?.('track', 'ViewContent', { ...PRODUCT_EVENT_PARAMS })
}

/** Fires InitiateCheckout, ignoring rapid repeated clicks. */
export function trackInitiateCheckout(): void {
  if (typeof window === 'undefined') return

  const now = Date.now()
  if (now - lastCheckoutSentAt < CHECKOUT_DEBOUNCE_MS) return
  lastCheckoutSentAt = now

  window.fbq?.('track', 'InitiateCheckout', { ...PRODUCT_EVENT_PARAMS })
}
